import React, { Component } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import _ from 'lodash';
import ReactApexChart from 'react-apexcharts';
import config from '../../config';

// TODO
// Error handle
// loading spinner
// possibly remove tools

class RegistrationWeeklyChartV2 extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
            type:props.type,
            height:props.height,
            maxHeight:props.maxHeight,
            loading:true,
            series: [],
            options: {
                chart: {
                    height: '100%',
                    type: 'line',
                    dropShadow: {
                        enabled: true,
                        color: '#000',
                        top: 18,
                        left: 7,
                        blur: 10,
                        opacity: 0.2
                    },
                    // stacked: true,
                    // stackType: '100%'
                },
                // plotOptions: {
                //     bar: {
                //         // horizontal: true,
                //         columnWidth: '100%',
                //     },
                // },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    width: 2,
                    curve: 'smooth'
                    // colors: ['#fff']
                },
                title: {
                    text: 'Vaccinations by Race/Ethnicity by Week'
                },
                xaxis: {
                    type: 'datetime',
                    categories: [],
                    labels: {
                        datetimeFormatter: {
                            year: 'yyyy',
                            month: 'MMM dd',
                            day: 'MMM dd',
                        }
                    }
                },
                yaxis: [],
                legend: {
                    horizontalAlign: 'left',
                    offsetX: 0
                },
                tooltip: {
                    enabled: true,
                    enabledOnSeries: true,
                    shared: true,
                    followCursor: true,
                    intersect: false,
                    inverseOrder: false,
                    fillSeriesColor: false,
                    style: {
                        fontSize: '11px',
                    },
                    onDatasetHover: {
                        highlightDataSeries: true,
                    },
                    y: [
                        {
                            formatter: function(value) {
                                return value.toString()+"%";
                            }
                        }
                    ],
                    marker: {
                        show: true,
                    },
                },
            },
      };
    }

    roundPercent(value){
        let thisGuy=value*100;
        thisGuy=Math.round(thisGuy * 10) / 10;
        return thisGuy;
    }

    async loadOut(){
        // const qValues = qs.parse(this.props.location.search);
        let formData;
        let qResp;
        let qData;
        let qWhere="1=1";
        let url=config.apiv2.registrationWeekly;
        let theDate=[];
        let theAsianData=[];
        let theBlackData=[];
        let theHispanicData=[];
        let theOtherData=[];
        let theWhiteData=[];
        let maxMinChecker=[];


        formData=new FormData();
        formData.append("where",qWhere);
        formData.append("outFields","*");
        formData.append("returnGeometry","false");
        formData.append("orderByFields","dateWeek");
        formData.append("returnDistinctValues","false");
        formData.append("f","json");

        try{
            qResp = await fetch(url+"/query",{method:"post",body:formData});
            qData = await qResp.json();
        }catch(err){
            console.log(err);
        }

        if(_.get(qData,"features.length",0)>0){
            for (const [key,value] of Object.entries(qData.features)){
                theDate.push(value.attributes.dateWeek);
                maxMinChecker.push(this.roundPercent(value.attributes.Asian));
                maxMinChecker.push(this.roundPercent(value.attributes.Black));
                maxMinChecker.push(this.roundPercent(value.attributes.Hispanic));
                maxMinChecker.push(this.roundPercent(value.attributes.Other));

                theAsianData.push(this.roundPercent(value.attributes.Asian));
                theBlackData.push(this.roundPercent(value.attributes.Black));
                theHispanicData.push(this.roundPercent(value.attributes.Hispanic));
                theOtherData.push(this.roundPercent(value.attributes.Other));
                theWhiteData.push(this.roundPercent(value.attributes.White));
            }

            // let minNormal=Math.min.apply(Math,maxMinChecker);
            // let maxNormal=Math.max.apply(Math,maxMinChecker);
            // let minWhite=Math.min.apply(Math,theWhiteData);
            // let maxWhite=Math.max.apply(Math,theWhiteData);
            
            this.setState({
                loading:false,
                error:false,
                series: [
                    {
                        name:'Asian',
                        data:theAsianData
                    },
                    {
                        name:'Black',
                        data:theBlackData
                    },
                    {
                        name:'Hispanic',
                        data:theHispanicData
                    },
                    {
                        name:'Other',
                        data:theOtherData
                    },
                    {
                        name:'White',
                        data:theWhiteData
                    },
                    
                ],
                options: {
                    ...this.state.options,
                    xaxis: {
                        ...this.state.options.xaxis,
                        categories:theDate,
                        tickAmount:theDate.length
                    },
                    yaxis: [
                        {
                            logarithmic:true,
                            tickAmount:9,
                            show:true,
                            labels: {
                                show:true,
                                formatter: function(value) {
                                    return value.toString()+"%";
                                }
                            },
                            title: {
                                text: undefined,
                            },
                            tooltip: {
                                enabled: false
                            },
                            min:2,
                            max:100
                        }
                    ]
                    
                }
            });
        }else{
            // error handle
            this.setState({
                loading:false,
                error:true
            });
        }
    }

    componentDidMount(){
        this.loadOut();
    }

    render() {
        if(this.state.loading===true){
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <div id="loader" style={{textAlign:"center"}}>
                        <Row>
                            <Col>
                                <Spinner animation="border" variant="primary" />
                            </Col>
                        </Row>
                    </div>
                </Container>
            );

        }else if(this.state.loading===false && this.state.error===true){
            //show error
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <Alert></Alert>
                </Container>
            );
        }else{
            return (
                <>
                    <div id="chart" style={{height:this.state.height,maxHeight:this.state.maxHeight,paddingRight:"0",paddingLeft:"0"}}>
                        <ReactApexChart options={this.state.options} series={this.state.series} type="line" height={'100%'} />
                    </div>
                </>
            );
        }
    }
}

export default RegistrationWeeklyChartV2;